---
title: Termini
updated: 2026-10-02
---

## 1. Accettazione dei Termini

Creando un account o utilizzando Draughts Game ("il Servizio"), accetti di essere vincolato da questi Termini di Servizio. Se non sei d'accordo, ti preghiamo di non utilizzare il Servizio.

## 2. Descrizione del Servizio

Draughts Game è una piattaforma online per giocare a dama in più varianti. Il Servizio include matchmaking contro altri giocatori o contro il computer, tornei, rating dei giocatori, problemi di tattica e funzionalità di analisi delle partite.

## 3. Registrazione Account

Per accedere a determinate funzionalità, devi creare un account fornendo un nome utente, indirizzo email e password. Devi verificare il tuo indirizzo email prima di poter accedere. Sei responsabile della riservatezza delle tue credenziali di accesso. Puoi anche giocare come ospite senza registrazione, con funzionalità limitate.

- Devi avere almeno 16 anni per creare un account.
- Puoi creare un solo account per persona.
- Sei responsabile di tutta l'attività che avviene sotto il tuo account.

## 4. Condotta dell'Utente

Utilizzando il Servizio, accetti di non:

- Utilizzare assistenza esterna (motori, solutori) durante le partite classificate.
- Perdere intenzionalmente le partite per manipolare il rating (sandbagging).
- Colludere con altri giocatori nei tornei.
- Molestare, minacciare o abusare di altri utenti.
- Creare più account per eludere ban o manipolare le classifiche.
- Tentare di sfruttare bug o vulnerabilità nella piattaforma.
- Utilizzare strumenti automatizzati (bot) per giocare senza autorizzazione.

## 5. Fair Play

Ci riserviamo il diritto di utilizzare sistemi per rilevare imbrogli e gioco scorretto. Le violazioni possono comportare avvertimenti, sospensioni temporanee, aggiustamenti del rating o ban permanenti a nostra discrezione.

## 6. Proprietà Intellettuale

Il Servizio, incluso il suo design, codice originale, grafica e contenuti, è di proprietà di Draughts Game. I registri delle partite (mosse, risultati) sono dati pubblici e possono essere condivisi liberamente. I contenuti generati dagli utenti (nomi utente, messaggi chat) rimangono proprietà dei rispettivi autori.

## 7. Disponibilità e Modifiche

Ci impegniamo a mantenere il Servizio disponibile in ogni momento, ma non garantiamo un accesso ininterrotto. Ci riserviamo il diritto di modificare, sospendere o interrompere qualsiasi parte del Servizio in qualsiasi momento. Potremmo aggiornare questi Termini di tanto in tanto. L'uso continuato del Servizio dopo le modifiche costituisce accettazione.

## 8. Limitazione di Responsabilità

Il Servizio è fornito "così com'è" senza garanzie di alcun tipo, esplicite o implicite. Non siamo responsabili per danni indiretti, incidentali o consequenziali derivanti dall'uso del Servizio. La nostra responsabilità totale non supererà l'importo che ci hai pagato nei 12 mesi precedenti il reclamo (se presente).

## 9. Risoluzione

Puoi eliminare il tuo account in qualsiasi momento dalle impostazioni del profilo ("Elimina account"), oppure contattandoci. Possiamo terminare o sospendere il tuo account se violi questi Termini o adotti un comportamento dannoso per il Servizio o altri utenti.

## 10. Contatti

Per domande su questi Termini, contattaci all'indirizzo: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
